import requests from '@/utils/requests';

/**
 * 会场列表接口
 * @param {*} data
 */
export function venueList(data) {
  return requests({
    serviceName: 'devops-services',
    url: '/v1/business/venueQuery',
    method: 'post',
    data
  });
}

/**
 * 会场详情接口
 * @param {*} data
 */
export function venueDetail(data) {
  return requests({
    serviceName: 'devops-services',
    url: '/v1/business/venueQuery',
    method: 'post',
    data
  });
}

/**
 * 会场创建接口
 * @param {*} data
 */
export function venueCreate(data) {
  return requests({
    serviceName: 'devops-services',
    url: '/v1/business/venueCreate',
    method: 'post',
    data
  });
}

/**
 * 会场修改接口
 * @param {*} data
 */
export function venueModify(data) {
  return requests({
    serviceName: 'devops-services',
    url: '/v1/business/venueUpdate',
    method: 'post',
    data
  });
}

/**
 * 会场删除接口
 * @param {*} data
 */
export function venueDelete(data) {
  return requests({
    serviceName: 'devops-services',
    url: '/v1/business/venueDelete',
    method: 'post',
    data
  });
}

/**
 * 获取会场详情（包含所有相关数据）
 */
export function getVenueDetail(data) {
  return requests({
    serviceName: 'devops-services',
    url: '/v1/business/venueDetail',
    method: 'post',
    data
  });
}

/**
 * 更新会场状态
 */
export function venueStatusUpdate(data) {
  return requests({
    serviceName: 'devops-services',
    url: '/v1/business/venueStatus',
    method: 'post',
    data
  });
}

/**
 * 用户更新选择
 */
export function venueAction(data) {
  return requests({
    serviceName: 'devops-services',
    url: '/v1/business/venueAction',
    method: 'post',
    data
  });
}

/**
 * 会场产品查询
 */
export function venueProductQuery(data) {
  return requests({
    serviceName: 'devops-services',
    url: '/v1/business/venueProductQuery',
    method: 'post',
    data
  });
}
